// extracted by mini-css-extract-plugin
export default {"progress":"NFCSRetrieving_progress__Pv9z+","text":"NFCSRetrieving_text__Ih4Ms"};